module.exports = __webpack_public_path__ + "img/francisco.70efd4cb.png";